export default __webpack_public_path__ + "static/media/arrow-down.3829edc5.svg";